(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eot-product-panels"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('eot-product-panels')) customElements.define('eot-product-panels', class extends HTMLElement {
  connectedCallback() {
    if (this.dataset.enhanced) return;
    this.dataset.enhanced = 'true';
    const panels = [...this.querySelectorAll('details')];
    const nav = this.querySelector('.eot-panels__nav');
    const wide = matchMedia('(min-width: 901px)');
    let active = 0;
    nav.setAttribute('role', 'tablist');
    nav.setAttribute('aria-label', this.dataset.label);
    const buttons = panels.map((panel, index) => {
      const button = document.createElement('button');
      button.type = 'button'; button.id = panel.id + '-tab';
      button.textContent = panel.querySelector('summary').textContent;
      button.setAttribute('role', 'tab'); button.setAttribute('aria-controls', panel.id);
      button.addEventListener('click', () => { active = index; update(); });
      button.addEventListener('keydown', event => {
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % panels.length;
        else if (event.key === 'ArrowLeft') next = (index + panels.length - 1) % panels.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = panels.length - 1;
        else return;
        event.preventDefault(); active = next; update(); buttons[next].focus();
      });
      nav.append(button); return button;
    });
    const update = () => {
      nav.hidden = !wide.matches || !panels.length;
      panels.forEach((panel, index) => {
        buttons[index].setAttribute('aria-selected', String(index === active));
        buttons[index].tabIndex = index === active ? 0 : -1;
        panel.hidden = wide.matches && index !== active;
        if (wide.matches) {
          panel.open = true; panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', buttons[index].id);
        } else {
          panel.removeAttribute('role'); panel.removeAttribute('aria-labelledby');
          panel.open = index === active;
        }
      });
    };
    this._openLink = event => {
      const link = event.target.closest('a[href="#EotCarePanel"]');
      if (!link) return;
      const panel = this.querySelector(link.getAttribute('href'));
      if (!panel) return;
      event.preventDefault(); event.stopImmediatePropagation(); active = panels.indexOf(panel); update();
      panel.open = true;
      const target = wide.matches ? buttons[active] : panel.querySelector('summary');
      target.focus({preventScroll:true});
      target.scrollIntoView({block:'start'});
    };
    document.addEventListener('click', this._openLink, true);
    this._wide = wide; this._update = update;
    wide.addEventListener('change', update); update();
  }
  disconnectedCallback() { this._wide?.removeEventListener('change', this._update); document.removeEventListener('click', this._openLink, true); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
